import { render } from "./ImagePisto.vue?vue&type=template&id=40ca7b86&scoped=true"
import script from "./ImagePisto.vue?vue&type=script&lang=js"
export * from "./ImagePisto.vue?vue&type=script&lang=js"

import "./ImagePisto.vue?vue&type=style&index=0&id=40ca7b86&scoped=true&lang=css"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ca7b86"]])

export default __exports__